<table>
  <colgroup>
    <col/>
  </colgroup>
  <colgroup class="ny-beholdning">
    <col class="advarsel"/>
    <col span="6"/>
  </colgroup>
  <colgroup class="eksisterende-beholdning">
    <col class="nummer"/>
    <col span="4"/>
  </colgroup>
  <thead>
  <tr class="tittelrad--gruppering">
    <th class="navn"></th>
    <th colspan="7">{{ "Ny beholdning" | translate }}</th>
    <th colspan="5">{{ "Eksisterende beholdning (angres)" | translate }}</th>
  </tr>
  <tr class="tittelrad--kolonner">
    <th class="navn">{{ "Navn" | translate }}</th>
    <th class="advarsler"><!--advarsel--></th>
    <th class="nummer">{{ "Aksjenummer" | translate }}</th>
    <th class="antall">{{ "Antall" | translate }}</th>
    <th class="diff differanse-rad">{{ "Endring" | translate }}</th>
    <th class="andel">{{ "Eierandel" | translate }}</th>
    <th class="klasse">{{ "Klasse" | translate }}</th>
    <th class="innføringsdato">{{ "Innføringsdato" | translate }}</th>

    <th class="nummer">{{ "Aksjenummer" | translate }}</th>
    <th class="antall">{{ "Antall" | translate }}</th>
    <th class="andel">{{ "Eierandel" | translate }}</th>
    <th class="klasse">{{ "Klasse" | translate }}</th>
    <th class="innføringsdato">{{ "Innføringsdato" | translate }}</th>
  </tr>
  </thead>

  @for (beholdningmodell of beholdninger(); track beholdningmodell.aksjeeier.id){
    <tbody>
    <tr data-testid="aksjeeier" [ngClass]="{'positiv':beholdningmodell.antallAksjerDifferanse() > 0, 'negativ':beholdningmodell.antallAksjerDifferanse() < 0, 'samme':beholdningmodell.erEndret() && beholdningmodell.antallAksjerDifferanse() == 0, 'uendret':!beholdningmodell.erEndret()}">
      <td class="navn">{{ beholdningmodell.aksjeeier.navn }}</td>
      <td class="advarsler">
        @if(beholdningmodell.harAdvarsler()){
          <i class="icon ion-android-warning" [matTooltip]="beholdningmodell.advarslerTooltipTekst()"></i>
        }
      </td>
      <td class="nummer">{{beholdningmodell.aksjenummerKtrl.value}}</td>
      <td class="antall">{{ beholdningmodell.antallAksjer() }}</td>
      <!--unngå mellomrom mellom <span> og verdi for å unngå avstand mellom '+' og verdi -->
      <td class="diff"><span class="diff--sirkel">{{ beholdningmodell.antallAksjerDifferanse() }}</span></td>
      <td class="andel">{{ beholdningmodell.eierandel() | percent }}</td>
      <td class="klasse">
        {{beholdningmodell.aksjeklasseKtrl.value?.navn}}
      </td>
      <td class="innføringsdato">{{ beholdningmodell.nyInnfoeringsdato | plaindate:'medium' }}</td>

      <td class="nummer">{{ beholdningmodell.aksjeeier.naavaerendeBeholdning?.aksjenummer }}</td>
      <td class="antall">{{ beholdningmodell.aksjeeier.naavaerendeBeholdning?.antall }}</td>
      <td class="andel">{{ beholdningmodell.aksjeeier.naavaerendeBeholdning?.eierandel | prosent }}</td>
      <td class="klasse">{{ beholdningmodell.aksjeeier.naavaerendeBeholdning?.aksjeklasse?.navn }}</td>
      <td class="innføringsdato">{{ beholdningmodell.aksjeeier.naavaerendeBeholdning?.gyldigFraTil?.start | plaindate:'medium' }}</td>
    </tr>
    </tbody>
  }

  <tfoot>
  <tr [ngClass]="{'positiv':modell.totaltAntallAksjerDifferanse() > 0, 'negativ':modell.totaltAntallAksjerDifferanse() < 0, 'uendret':modell.totaltAntallAksjerDifferanse() == 0}">
    <td class="navn"><!--navn-->{{ "Totalt" | translate }}</td>
    <td class="advarsler"><!--advarsel--></td>
    <td class="nummer">{{ modell.aksjenummerIBruk()|aksjenummerintervaller }}</td>
    <td class="antall">{{ modell.totaltAntallAksjer() }}</td>
    <!--unngå mellomrom mellom <span> og verdi for å unngå avstand mellom '+' og verdi -->
    <td class="diff"><span class="diff--sirkel">{{ modell.totaltAntallAksjerDifferanse() }}</span></td>
    <td class="andel"><!--eierandel--></td>
    <td class="klasse">
      @if (modell.totaltAntallAksjerPerAksjeklasse().size > 1){
        <antall-aksjer-per-aksjeklasse [aksjeklasserMedAntall]="modell.totaltAntallAksjerPerAksjeklasse()"/>
      }
    </td>
    <td class="innføringsdato"><!--innføringsdato--></td>

    <td class="nummer">{{ modell.eksisterendeAksjenummerIBruk|aksjenummerintervaller }}</td>
    <td class="antall">{{ modell.eksisterendeTotaltAntallAksjer }}</td>
    <td class="andel"><!--eierandel--></td>
    <td class="klasse">
      @if (modell.eksisterendeTotaltAntallAksjerPerAksjeklasse.size > 1){
        <antall-aksjer-per-aksjeklasse [aksjeklasserMedAntall]="modell.eksisterendeTotaltAntallAksjerPerAksjeklasse"/>
      }
    </td>
    <td class="innføringsdato"><!--innføringsdato--></td>
  </tr>
  </tfoot>

</table>

@if (modell.aksjenummerIkkeIBruk().length > 0) {
  <div class="meldinger-til-bruker">
    <inline-melding type="feil">
      {{ "Aksjene {aksjenummerintervaller}  mangler eier" | translate: {aksjenummerintervaller: modell.aksjenummerIkkeIBruk()|aksjenummerintervaller } }}
    </inline-melding>
  </div>
}
